import styles from './Informations.module.scss'
import BasketProductCard, { renderBasketProductCardSkeletons } from '../../../Order/ui/OrderCards/OrderProductCard'
import { CartIconWhite } from 'shared/assets'
import { NavLink } from 'react-router-dom'
import { ERoutePaths } from 'libraries/router/types'

function MainBasketInformations({
  basketListLoading,
  is_supplier,
  basketList,
  loading,
  closeDrawer,
  renderBasketCartInformation,
}: any) {
  const renderBasketCards = BasketProductCard()

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.content__cards}>
          {basketListLoading ? renderBasketProductCardSkeletons : renderBasketCards}
        </div>
      </div>
    </div>
  )
}

export default MainBasketInformations
